import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail_qq.svg';
const MailQq = () => React.createElement(IconSvg, null);
export default MailQq;
